import React, { createContext, PropsWithChildren, useContext } from 'react';
import { isNull } from '../../../lib/typeGuards';

type BlockInteractionContext = {
  switchToDefaultView(): void;
};

export const BlockInteractionContext = createContext<BlockInteractionContext | null>(null);

export function BlockInteractionContextProvider({ children, ...props }: PropsWithChildren<BlockInteractionContext>) {
  return <BlockInteractionContext.Provider value={props}>{children}</BlockInteractionContext.Provider>;
}

export function useBlockInteractionContext() {
  const value = useContext(BlockInteractionContext);
  if (isNull(value)) {
    throw Error('BlockInteractionContext is used without Provider');
  }
  return value;
}
